import { useEffect, useRef, useState } from 'react';
import apiCaller from 'services/Api/ApiCaller';
import { API_URL } from 'settings';

export type RealtimeSessionCounts = {
  as_of: string;
  online_available: boolean;
  counts: { sessions: number; active: number | null; online: number | null };
};

export default function useRealtimeSessionCounts() {
  const [refresh, setRefresh] = useState(0);
  const inFlight = useRef(false);
  const [state, setState] = useState<{
    data?: RealtimeSessionCounts;
    loading: boolean;
    error: boolean;
  }>({ loading: true, error: false });

  useEffect(() => {
    const controller = new AbortController();
    inFlight.current = true;
    setState(previous => ({ ...previous, loading: true, error: false }));
    void apiCaller({
      apiUrl: API_URL,
      path: '/sessions/admin_realtime_counts/',
      signal: controller.signal,
    })
      .then(response => {
        if (controller.signal.aborted) return;
        if (response.status !== 200) throw new Error('Totals unavailable');
        setState({ data: response.result, loading: false, error: false });
      })
      .catch(() => {
        if (!controller.signal.aborted)
          setState(previous => ({ ...previous, loading: false, error: true }));
      })
      .finally(() => {
        if (!controller.signal.aborted) inFlight.current = false;
      });
    return () => {
      controller.abort();
      inFlight.current = false;
    };
  }, [refresh]);

  return {
    ...state,
    refresh: () => {
      if (inFlight.current) return;
      inFlight.current = true;
      setRefresh(value => value + 1);
    },
  };
}
